import { cn } from '@/lib/utils';

import { IMAGE_SIZE, sizingClass } from '../tokens';
import { isHttpsUrl } from '../urls';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

export const Image: ComponentFn<typeof catalog, 'Image'> = ({ props }) =>
  isHttpsUrl(props.src) ? (
    <img
      src={props.src}
      alt={props.alt}
      loading="lazy"
      referrerPolicy="no-referrer"
      className={cn(
        props.size
          ? IMAGE_SIZE[props.size]
          : 'max-h-[calc(256*var(--ac-u))] max-w-full rounded-lg border border-border object-contain',
        sizingClass(props.sizing) || 'shrink-0'
      )}
    />
  ) : null;
